module.exports = __webpack_public_path__ + "img/img_boy_game.10b02111.svg";